@if (signaalkaart$ | async; as signaalkaart) {
  @if (signaalkaartAntwoord$ | async; as signaalkaartAntwoord) {
    @if (client$ | async; as client) {
      <zah-signaalkaart-antwoord-header [signaalkaartAntwoord]="signaalkaartAntwoord"
        [signaalkaart]="signaalkaart"
        [client]="client">
      </zah-signaalkaart-antwoord-header>
      <div class="content">
        <zah-signaalkaart [signaalkaart]="signaalkaart"
          [signaalkaartAntwoord]="signaalkaartAntwoord">
        </zah-signaalkaart>
        <button mat-mini-fab
          color="primary"
          class="back-button"
          (click)="navigateBack()">
          <mat-icon>arrow_back</mat-icon>
        </button>
      </div>
    }
  }
}
